import type { AgentApiCandidateFormsShow } from '@/types/serializers';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateCandidateFormThanksParams {
  thanks_title?: string | null;
  thanks_message?: string | null;
  header_tag?: string | null;
}

/**
 * サンクスページ・ヘッダータグ更新用のフック
 */
export default function useUpdateCandidateFormThanks() {
  const queryClient = useQueryClient();
  const token =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '';

  return useMutation({
    mutationFn: async (params: UpdateCandidateFormThanksParams) => {
      const response = await fetch('/agent/api/candidate_forms', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          candidate_form: params,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          (Array.isArray(errorData.errors) ? errorData.errors.join(', ') : errorData.errors) ||
            'サンクスページの保存に失敗しました'
        );
      }

      const data: AgentApiCandidateFormsShow = await response.json();
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['candidate_forms'] });
    },
  });
}
